import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';
import { FaVideo } from 'react-icons/fa';

import { PaginationComponent } from 'pages/SearchPage/components/Pagination';
import './MeetingsTab.css';

import i18n from 'i18n';
import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';
import { EmptyFieldWarning } from 'pages/EHRPage/components/EmptyFieldWarning';

export function MeetingsTab({ data = [], hasAccess }) {
  const { compareDates } = useTeleconsultingContext();
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil(data.length / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;
  const currentItems = data?.slice(startIndex, endIndex);

  const typeDict = {
    'HOSPITAL UNIVERSIT?RIO J?LIO BANDEIRA':
      'Hospital Universitário Júlio Bandeira',
  };

  // function filterToDisplayList(listToFilter) {
  //   return listToFilter.slice(startIndex, endIndex);
  // }

  return (

    <>
      {
        data.length ? (
          <div className="meetingsTable">
            <div className="teleconsultingTitleTable">
              {hasAccess
                ? <p>Lista de teleatendimentos agendados</p>
                : <p>Lista de teleatendimentos realizados</p>}
            </div>
            <div
              className={
                hasAccess ? 'meetingsTableHeader' : 'meetingsTableHeaderFourColumns'
              }
            >
              <div className="descriptionMeetings">
                <p>Descrição</p>
              </div>
              <div className="unidadeSaude">
                <p>Unidade de saúde</p>
              </div>
              <div className="dateMeetings">
                <p>Data</p>
              </div>
              <div className="timeMeetings">
                <p>Hora</p>
              </div>
              {hasAccess && (
                <div className="accessMeetings">
                  <p>Acesso</p>
                </div>
              )}
            </div>
            {currentItems ? (
              <>
                {currentItems.map((option, index) => (
                  <>
                    <div
                      role="list"
                      key={`MeetingsTab-${index}`}
                      className={
                        hasAccess
                          ? 'meetingsTableBody'
                          : 'meetingsTableBodyFourColumns'
                      }
                    >
                      <div className="descriptionMeetings">
                        <p>{option?.resource?.appointmentType.text || ''}</p>
                      </div>
                      <div className="unidadeSaude">
                        <p>
                          {typeDict[
                            option?.resource.participant.find(
                              (auxParticipant) => auxParticipant.actor.type === 'Location',
                            )?.actor?.display
                          ]
                            || option?.resource.participant.find(
                              (auxParticipant) => auxParticipant.actor.type === 'Location',
                            )?.actor?.display}
                        </p>
                      </div>
                      <div className="dateMeetings">
                        <p>
                          {formatISO2DisplayDateString(
                            option?.resource?.start,
                            i18n.language,
                          ) || ''}
                        </p>
                      </div>
                      <div className="timeMeetings">
                        <p>
                          {formatISO2DisplayTimeString(
                            option?.resource?.start,
                            i18n.language,
                          ).slice(0, -3) || ''}
                        </p>
                      </div>
                      {hasAccess && (
                        <div className="accessMeetings">
                          {compareDates(option?.resource?.start) ? (
                            <a className="url-stt" href={option.resource.comment}>
                              <button className="deleteButton">
                                <FaVideo className="meetingsTableVideoIconActive" />
                              </button>
                            </a>
                          ) : (
                            <FaVideo className="meetingsTableVideoIcon" />
                          )}
                        </div>
                      )}
                    </div>
                    <hr className="division" />
                  </>
                ))}
              </>
            ) : (
              <></>
            )}
            <PaginationComponent
              items={itensPerPage}
              totalItens={data.length}
              setItensPerPage={setItensPerPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              currentPage={currentPage}
            />
          </div>
        ) : <EmptyFieldWarning />
      }
    </>
  );
}

MeetingsTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  hasAccess: PropTypes.bool.isRequired,
};
